<nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/portal/home"
      ><i class="bi bi-grid-1x2-fill me-1"></i>Encuestas</a
    ><button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#portalNav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="portalNav">
      <div class="me-auto"></div>
      <div class="d-flex gap-2 align-items-center">
        <app-theme-toggle></app-theme-toggle>
        @if (session.isAuthenticated()) {
          <span class="navbar-text text-white border border-light rounded px-2">{{
            session.userName()
          }}</span>
          @if (sessionTimer.remainingTime(); as remainingTime) {
            <span class="navbar-text text-white border border-light rounded px-2">
              <i class="bi bi-clock me-1"></i>{{ remainingTime }}
            </span>
          }
          <a class="btn btn-outline-light" routerLink="/working/dashboard">Gestión</a
          ><button class="btn btn-outline-light" type="button" (click)="logout()">
            Cerrar sesión
          </button>
        }
      </div>
    </div>
  </div>
</nav>
